import "./css/footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer">
      DSolve &copy; 2022
      {currentYear !== 2022 ? "-" + currentYear : ""}
    </div>
  );
}

export default Footer;